define 'controller/LoginIdentificationFormController', ['jquery', 'lib/kryptonite', 'lib/easy-autocomplete', 'lib/formdata'], ($) ->
  class LoginIdentificationFormController

    constructor: (@$el) ->
      @_updateViewStateButtonLoginNewCustomer()
      @_submitCreateNewCustomer()
      @_triggerSpinner()
      @_hideErrorMessagesOnTyping()
      @_showCreateAccountButtonOnTyping()
      @_autocompleteMail()
      @_selectAutocompleteOption()
      @_showSubmitButton()

      # for frontend-tests
      @$el.attr('data-initialized', true);

    _showSubmitButton: ->
      $('#inputLoginMailOrWelcomeNumber').on('input', ( ->
        $('#loginButtonLoginpage').addClass('js-show')
        $('#loginButtonLoginpage').removeClass('js-hide')
      ))

    _selectAutocompleteOption: ->
      $('#eac-container-inputLoginMailOrWelcomeNumber').on('click', ( ->
        $('#buttonLoginNewCustomer').prop('disabled', false)
      ));


    _autocompleteMail: ->
      $el = $('#inputLoginMailOrWelcomeNumber')
      if $el.length > 0
        options =
          url: (phrase) ->
            $el.data('url') + '?email=' + phrase + '&format=json'
          getValue: (element) ->
            element.mailAddress
          list:
            maxNumberOfElements: 10
            match:
              enabled: true
            onClickEvent: ->
            onKeyEnterEvent: ->
          requestDelay: 150
          minCharNumber: 1
          adjustWidth : false
        $el.easyAutocomplete(options)

    _updateViewStateButtonLoginNewCustomer: ->
      self = @

      if self._isMailAddress($('input#inputLoginMailOrWelcomeNumber').val()) || self._isNumber($('input#inputLoginMailOrWelcomeNumber').val())
        $('#buttonLoginNewCustomer').prop('disabled', false)

      $('input#inputLoginMailOrWelcomeNumber').on 'input', ->
        inputValueMailOrNumber = $(this).val()

        if self._isMailAddress(inputValueMailOrNumber) || self._isNumber(inputValueMailOrNumber)
          $('#buttonLoginNewCustomer').prop('disabled', false)
        else
          $('#buttonLoginNewCustomer').prop('disabled', true)

    _submitCreateNewCustomer: ->
      self = @

      $('.login').on 'submit', '#formNewCustomer', (e) ->
        inputValueMailOrNumber = $('input#inputLoginMailOrWelcomeNumber').val()

        if self._isMailAddress(inputValueMailOrNumber)
          $('input#inputLoginMailOrWelcomeNumber').attr('name', 'email')
        else
          $('input#inputLoginMailOrWelcomeNumber').attr('name', 'loginNumero')

    _isMailAddress: (inputText) ->
      re = /(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z\-0-9]{1,}))/
      isMailAddress = re.test inputText
      return isMailAddress

    _isNumber: (inputText) ->
      re = /^\d+([;,.\s]\d+)*$/
      isNumber = re.test inputText
      return isNumber

    _triggerSpinner: ->
      $('.login').on 'submit', '#formNewCustomer', (e) ->
        overlay = jQuery('<div data-test-loading-overlay id="loading-overlay"><div class="loading-circle"></div></div>')
        overlay.appendTo document.body

    _hideErrorMessagesOnTyping: ->
      $('.toggleErrorMessages').on 'input', ->
        $('.error').slideUp('slow')

    _showCreateAccountButtonOnTyping: ->
      $('#inputLoginMailOrWelcomeNumber').on 'input', ->
        $('.login__create-account').slideUp('slow')

    destroy: ->
      @$el.off()